export default __webpack_public_path__ + "static/media/banner-meld.605bb1a7.jpg";